import type { EVENT_PROP_ALLOWLIST } from './analytics-schema.js';

export const CUSTOMER_ANALYTICS_POLICY_VERSION = '2026-09-20';
export const CUSTOMER_ANALYTICS_RETENTION_DAYS = 90;

export interface CustomerAnalyticsPreference {
  signed_in: boolean;
  account_id: number | null;
  needs_prompt: boolean;
  enabled: boolean;
  grant_id: string | null;
  policy_version: string;
  granted_at: string | null;
}

const CUSTOMER_EVENTS = new Set<string>([
  'session_mode', 'session_action_draw', 'session_action_search', 'session_action_share',
  'editor_activated', 'viewer_became_editor', 'tool_selected',
  'save_clicked', 'save_completed', 'map_save_failed', 'map_created', 'map_updated',
  'import_attempted', 'import_succeeded', 'import_failed',
  'export_png_clicked', 'export_png_succeeded', 'export_png_failed',
  'export_pdf_clicked', 'export_pdf_succeeded', 'export_pdf_failed',
  'export_preview_shown', 'export_settings_confirmed', 'checkout_export_completed',
  'share_clicked', 'share_copy_succeeded', 'share_native_succeeded', 'share_clipboard_succeeded', 'search_attempted', 'search_succeeded',
  'search_failed', 'search_failed_http', 'search_failed_network', 'search_failed_parse',
  'pro_checkout_clicked', 'pro_checkout_failed', 'pro_checkout_embedded_opened',
  'pro_checkout_embedded_closed', 'pro_checkout_completed', 'pro_checkout_payment_failed',
  'runtime_error', 'console_error', 'ai_map_submit_attempted', 'ai_map_plan_received',
  'ai_map_plan_applied', 'ai_map_user_retry', 'ai_map_performance', 'ai_map_saved_after_use', 'ai_map_export_after_use',
  'rp_route_succeeded', 'rp_route_failed', 'rp_session_mode', 'distance_session_mode',
] satisfies (keyof typeof EVENT_PROP_ALLOWLIST)[]);

const CUSTOMER_PROPERTIES = new Set([
  'tool', 'format', 'reason', 'operation', 'http_status', 'duration_ms', 'feature',
  'source', 'purchase', 'session_mode', 'traffic_source', 'search_intent',
  'app_locale', 'watermarked', 'outcome', 'variant', 'file_type', 'status',
]);

export function customerEventProps(event: string, props: Record<string, string>): Record<string, string> | null {
  if (!CUSTOMER_EVENTS.has(event)) return null;
  return Object.fromEntries(Object.entries(props).filter(([key, value]) =>
    CUSTOMER_PROPERTIES.has(key) && /^[a-zA-Z0-9_.-]{1,64}$/.test(value),
  ));
}
